import * as Yup from 'yup'

export const forgotSchema = Yup.object().shape({
  email: Yup.string().email('Digite um email válido').required('Required'),
})
